function getCommonHeaders() {
    return {
        'X-WO-CLIENT-PLATFORM': 'WEB',
        'X-WO-CLIENT-APP-NAME': 'Website',
        'X-WO-CLIENT-APP-PACKAGE': 'Website',
        'X-WO-CLIENT-APP-VERSION': '1.0',
        'X-WO-CLIENT-APP-BUILD-NUMBER': '0',
        'X-WO-CLIENT-CURRENT-SYSTEM-TIME': new Date().toISOString(),
    };
}

async function interceptorFetch(...args) {
    try {
        const response = await fetch(...args);
        return response;
    } catch (err) {
        console.error('Fetch error:', err);
        throw err; // Re-throw the error for the calling function to handle
    }
}

async function get(url = '', recaptchaToken = '') {
    const commonHeaders = getCommonHeaders();

    const headers = {
        ...commonHeaders,
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
    };

    if (recaptchaToken) {
        headers['Recaptcha'] = recaptchaToken; // Keep the header name as 'Recaptcha'
    }

    const response = await interceptorFetch(url, { headers });

    if (!response.ok) {
        const errorText = await response.text();
        console.error('HTTP GET Error:', response.status, errorText);
        throw new Error(`HTTP GET Error ${response.status}: ${errorText}`);
    }

    return await response.json();
}

async function post(url = '', data = {}, recaptchaToken = '') {
    const commonHeaders = getCommonHeaders();

    const headers = {
        ...commonHeaders,
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
    };

    if (recaptchaToken) {
        headers['Recaptcha'] = recaptchaToken; // Keep the header name as 'Recaptcha'
    }

    const response = await interceptorFetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error('HTTP POST Error:', response.status, errorText);
        throw new Error(`HTTP POST Error ${response.status}: ${errorText}`);
    }

    return await response.json();
}

async function patch(url = '', data = {}, recaptchaToken = '') {
    const commonHeaders = getCommonHeaders();

    const headers = {
        ...commonHeaders,
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
    };

    if (recaptchaToken) {
        headers['Recaptcha'] = recaptchaToken; // Keep the header name as 'Recaptcha'
    }

    const response = await interceptorFetch(url, {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error('HTTP PATCH Error:', response.status, errorText);
        throw new Error(`HTTP PATCH Error ${response.status}: ${errorText}`);
    }

    return await response.json();
}

async function put(url = '', data = {}, recaptchaToken = '') {
    const commonHeaders = getCommonHeaders();

    const headers = {
        ...commonHeaders,
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
    };

    if (recaptchaToken) {
        headers['Recaptcha'] = recaptchaToken; // Keep the header name as 'Recaptcha'
    }

    const response = await interceptorFetch(url, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        const errorText = await response.text();
        console.error('HTTP PUT Error:', response.status, errorText);
        throw new Error(`HTTP PUT Error ${response.status}: ${errorText}`);
    }

    return await response.json();
}
